/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AwardWalletConnectionInfoResponse
 */
export interface AwardWalletConnectionInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AwardWalletConnectionInfoResponse
     */
    connected: boolean;
    /**
     * 
     * @type {number}
     * @memberof AwardWalletConnectionInfoResponse
     */
    awardwalletUserId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof AwardWalletConnectionInfoResponse
     */
    connectedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AwardWalletConnectionInfoResponse
     */
    lastSyncedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AwardWalletConnectionInfoResponse
     */
    lastSyncError?: string | null;
    /**
     * Number of AwardWallet source accounts currently linked to the
     * user's connection (0 when the user has no loyalty programs on
     * AwardWallet's side or before any sync has run).
     * 
     * @type {number}
     * @memberof AwardWalletConnectionInfoResponse
     */
    sourceAccountCount: number;
}

/**
 * Check if a given object implements the AwardWalletConnectionInfoResponse interface.
 */
export function instanceOfAwardWalletConnectionInfoResponse(value: object): value is AwardWalletConnectionInfoResponse {
    if (!('connected' in value) || value['connected'] === undefined) return false;
    if (!('sourceAccountCount' in value) || value['sourceAccountCount'] === undefined) return false;
    return true;
}

export function AwardWalletConnectionInfoResponseFromJSON(json: any): AwardWalletConnectionInfoResponse {
    return AwardWalletConnectionInfoResponseFromJSONTyped(json, false);
}

export function AwardWalletConnectionInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwardWalletConnectionInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'connected': json['connected'],
        'awardwalletUserId': json['awardwallet_user_id'] == null ? undefined : json['awardwallet_user_id'],
        'connectedAt': json['connected_at'] == null ? undefined : (new Date(json['connected_at'])),
        'lastSyncedAt': json['last_synced_at'] == null ? undefined : (new Date(json['last_synced_at'])),
        'lastSyncError': json['last_sync_error'] == null ? undefined : json['last_sync_error'],
        'sourceAccountCount': json['source_account_count'],
    };
}

export function AwardWalletConnectionInfoResponseToJSON(json: any): AwardWalletConnectionInfoResponse {
    return AwardWalletConnectionInfoResponseToJSONTyped(json, false);
}

export function AwardWalletConnectionInfoResponseToJSONTyped(value?: AwardWalletConnectionInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'connected': value['connected'],
        'awardwallet_user_id': value['awardwalletUserId'],
        'connected_at': value['connectedAt'] == null ? value['connectedAt'] : value['connectedAt'].toISOString(),
        'last_synced_at': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
        'last_sync_error': value['lastSyncError'],
        'source_account_count': value['sourceAccountCount'],
    };
}

